export const isEmail = new RegExp(/^[\w+-.]+@([\w-]+\.)+[\w-]{2,}$/g);

export const regexLowerCase = new RegExp(/^(?=.*[a-z]).*$/);
export const regexUpperCase = new RegExp(/^(?=.*[A-Z]).*$/);
export const regexDigits = new RegExp(/^(?=.*[0-9]).*$/);
export const regexSpecialCharacters = new RegExp(/^(?=.*[¡¿?""*¨[\]`^~!«#$%&‘()*+,\-_./]).*$/);
export const regexSpecialCharName = new RegExp(/^(?=.*[¡¿?""*¨'[\]`^~!{}«#$%&‘()*+,\-_./]).*$/);
export const regexUrlScreenings = new RegExp(/^https:\/\/campus(-dev|-test|-preprod|).alkemy.org\/home\?invitation=[a-zA-Z0-9-_]+$/);
export const checkPassword = (regex, string) => regex.test(string);
